type UrlParts = { pathname: string; search: string; hash: string };

export const isSamePageAnchorNavigation = (
  previous: Pick<UrlParts, 'pathname' | 'search'> | null | undefined,
  next: UrlParts,
): boolean => !!previous && next.hash !== '' && previous.pathname === next.pathname && previous.search === next.search;
